module.exports = __webpack_public_path__ + "static/media/visibleShare.b53216c7.svg";